import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Avatar from "@mui/material/Avatar";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import EmptyMessage from "../../Containers/Donations/EmptyMessage";
import { PRODUCT_ICON } from "../../common/enum/productIcon";
import CollectionDonationProductCard from "./CollectionDonationProductCard";
import { ComponentType } from "../../common/enum";

const CollectionProducts = ({
  products,
  t,
  collectionProduct,
  setCollection,
  setProductError,
  componentType,
}) => {
  const groupDonationProduct = React.useMemo(() => {
    return products?.reduce((acc, pro) => {
      if (!acc[pro.productGroup]) {
        acc[pro.productGroup] = {};
        acc[pro.productGroup]["count"] = 0;
        acc[pro.productGroup]["Notcount"] = 0;
      }
      if (!acc[pro.productGroup][pro.productType]) {
        acc[pro.productGroup][pro.productType] = [];
      }
      if(pro.availableQuantity != 0 ){
        acc[pro.productGroup]["Notcount"] = acc[pro.productGroup]["Notcount"] + 1;
      }else{
        acc[pro.productGroup]["Notcount"] = 0;
      }
      acc[pro.productGroup]["count"] = acc[pro.productGroup]["count"] + 1;
      acc[pro.productGroup][pro.productType].push(pro);

      return acc;
    }, {});
  }, [products]);

  return (
    <>
      {" "}
      {Object.keys(groupDonationProduct).length == 0 && <EmptyMessage message={"noProductForThisDonation"} t={t} />}
      {groupDonationProduct !== undefined &&
        Object.keys(groupDonationProduct)?.map((item, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandCircleDownOutlinedIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                backgroundColor: "#e1efb0",
                "& .MuiAccordionSummary-content": {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  alt={
                    PRODUCT_ICON.find(
                      (itemIcon) => itemIcon.productGroup === item
                    ).productGroup
                  }
                  src={
                    PRODUCT_ICON.find(
                      (itemIcon) => itemIcon.productGroup === item
                    ).url
                  }
                  sx={{
                    width: 24,
                    height: 24,
                    ml: 0.2,
                    mr: 1,
                  }}
                />
                <Typography variant="h6">{item}</Typography>
              </Box>
              <Box
                sx={{
                  p: "2px 16px",
                  borderRadius: "40px",
                  backgroundColor: "primary.contrastText",
                  mr: 1,
                }}
              >
                <Typography variant="subtitle2" color={"primary"}>
                  {groupDonationProduct[item]["Notcount"] + "/" + groupDonationProduct[item]["count"]}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {Object.keys(groupDonationProduct[item]).map(
                (itemType, index) => (
                  <React.Fragment key={index}>
                    {itemType !== "count" && itemType !== "Notcount" && (
                      <Typography
                        variant="body1"
                        color={"text.secondary"}
                        my={2}
                      >
                        {itemType === "undefined" ? "Product Type" : itemType}
                      </Typography>
                    )}
                    <Grid container spacing={1}>
                      {itemType !== "count"  && itemType !== "Notcount" &&
                        groupDonationProduct[item][itemType].map((prod) => (
                          <Grid
                            item
                            xs={12}
                            sm={
                              componentType === ComponentType.AGENDA_PRODUCT
                                ? 12
                                : 6
                            }
                            key={prod.id}
                          >
                            <CollectionDonationProductCard
                              t={t}
                              donationProduct={prod}
                              collectionProduct={collectionProduct}
                              setCollectionProduct={setCollection}
                              setProductError={setProductError}
                              componentType={componentType}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </React.Fragment>
                )
              )}
            </AccordionDetails>
          </Accordion>
        ))}
    </>
  );
};

export default CollectionProducts;
